export default __webpack_public_path__ + "static/sleigh-bells-5c64aeba08b73d949e332c579d2acdb7.mp3";